import { lazy } from 'react';
import { RouteProps } from 'react-router';

export interface RouteObject extends RouteProps {
  exact: boolean;
  path: string;
  component: any;
}

// #region Admin Routes
const Landing = lazy(() => import('containers/Landing'));
const Signin = lazy(() => import('containers/Signin'));
const Onboarding = lazy(() => import('containers/Onboarding'));
const ForgotPassword = lazy(() => import('containers/ForgotPassword'));
// #endregion

// #region Public Routes
const FillReference = lazy(() => import('containers/FillReference'));
// #endregion

// #region Private Routes
const Home = lazy(() => import('containers/Home'));
const Settings = lazy(() => import('containers/Settings'));
const Profile = lazy(() => import('containers/Profile'));
const EditProfile = lazy(() => import('containers/EditProfile'));
const References = lazy(() => import('containers/References'));
const Documents = lazy(() => import('containers/Documents'));
const Account = lazy(() => import('containers/Account'));
const Notifications = lazy(() => import('containers/Notifications'));
const NotificationFrequency = lazy(
  () => import('containers/NotificationFrequency'),
);
const ChangePassword = lazy(() => import('containers/ChangePassword'));
const EditEmail = lazy(() => import('containers/EditEmail'));
const EditPhoneNumber = lazy(() => import('containers/EditPhoneNumber'));
const RequestReference = lazy(() => import('containers/RequestReference'));
const SubmittedReferences = lazy(
  () => import('containers/SubmittedReferences'),
);
const JobStatus = lazy(() => import('containers/JobStatus'));
const ToDo = lazy(() => import('containers/ToDo'));
// #endregion

// #region Admin Routes
const AdminUserReference = lazy(() => import('containers/AdminUserReference'));
const AdminUserProfile = lazy(() => import('containers/AdminUserProfile'));
const AdminPortal = lazy(() => import('containers/AdminPortal'));
const AdminAgencies = lazy(() => import('containers/AdminAgencies'));
const AdminAgency = lazy(() => import('containers/AdminAgency'));
const AdminMail = lazy(() => import('containers/AdminMail'));
const AdminUserStatus = lazy(() => import('containers/AdminUserStatus'));
// #endregion

// #region PUBLIC ROUTES
const PUBLIC_ROUTES: RouteObject[] = [
  {
    exact: true,
    path: '/fill-reference',
    component: FillReference,
  },
];
// #endregion

// #region AUTH ROUTES
const AUTH_ROUTES: RouteObject[] = [
  {
    exact: true,
    path: '/',
    component: Landing,
  },
  {
    exact: false,
    path: '/onboarding',
    component: Onboarding,
  },
  {
    exact: true,
    path: '/login',
    component: Signin,
  },
  {
    exact: true,
    path: '/forgot-password',
    component: ForgotPassword,
  },
];
// #endregion

// #region PRIVATE ROUTES
const PRIVATE_ROUTES: RouteObject[] = [
  {
    exact: true,
    path: '/home',
    component: Home,
  },
  {
    exact: true,
    path: '/settings',
    component: Settings,
  },
  {
    exact: true,
    path: '/settings/account',
    component: Account,
  },
  {
    exact: true,
    path: '/settings/notifications',
    component: Notifications,
  },
  {
    exact: true,
    path: '/settings/notification-frequency',
    component: NotificationFrequency,
  },
  {
    exact: true,
    path: '/settings/change-password',
    component: ChangePassword,
  },
  {
    exact: true,
    path: '/settings/edit-email',
    component: EditEmail,
  },
  {
    exact: true,
    path: '/settings/edit-phone',
    component: EditPhoneNumber,
  },
  {
    exact: true,
    path: '/profile',
    component: Profile,
  },
  {
    exact: true,
    path: '/edit-profile',
    component: EditProfile,
  },
  {
    exact: true,
    path: '/references',
    component: References,
  },
  {
    exact: true,
    path: '/references/request-reference',
    component: RequestReference,
  },
  {
    exact: true,
    path: '/references/submitted-references',
    component: SubmittedReferences,
  },
  {
    exact: true,
    path: '/documents/',
    component: Documents,
  },
  {
    exact: true,
    path: '/job-status',
    component: JobStatus,
  },
  {
    exact: true,
    path: '/todo',
    component: ToDo,
  },
];
// #endregion

// #region ADMIN ROUTES
const ADMIN_ROUTES: RouteObject[] = [
  {
    exact: true,
    path: '/admin/portal',
    component: AdminPortal,
  },
  {
    exact: true,
    path: '/admin/user/status/:userId',
    component: AdminUserStatus,
  },
  {
    exact: true,
    path: '/admin/mail',
    component: AdminMail,
  },
  {
    exact: true,
    path: '/admin/agencies',
    component: AdminAgencies,
  },
  {
    exact: true,
    path: '/admin/agency/:agencyId',
    component: AdminAgency,
  },
];
// #endregion

// #region ADMIN PDF ROUTES
const PDF_ROUTES: RouteObject[] = [
  {
    exact: true,
    path: '/pdf/reference/:referenceId',
    component: AdminUserReference,
  },
  {
    exact: true,
    path: '/pdf/user/:userId',
    component: AdminUserProfile,
  },
];
// #endregion

export { PUBLIC_ROUTES, AUTH_ROUTES, PRIVATE_ROUTES, ADMIN_ROUTES, PDF_ROUTES };
